import { useTranslation } from 'react-i18next';
import styles from './solution.module.scss';
import halfCircle from '../../assets/float-3.svg';
import stepSurvey from '../../assets/illu-survey.svg';
import stepProcess from '../../assets/illu-process.svg';
import stepSociogram from '../../assets/illu-sociogram.svg';

const Solution = () => {
	const [t] = useTranslation()
	return (
		<section id="solution" className={styles.container}>
			<div className={styles.content_wrapper}>
					<h5>{t('section.solution.title')}</h5>
					<h2>
					{t('section.solution.description1')}
						{/* <b>{t('section.solution.description2')}</b> */}
					</h2>

					{/* <iframe 
					width="560" 
					height="315" 
					src="https://www.youtube.com/embed/Lr276s-EI3w" 
					title="YouTube video player" 
					frameBorder="0" 
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					className={styles.video}
				></iframe> */}
				<div className={styles.infoSteps}>
					<span className={styles.step}>
						<img src={stepSurvey} className={styles.stepImage} />
						<p className={styles.stepDescription}>
						{t('section.solution.items.description')}
						</p>
					</span>
					<span className={styles.step}>
						<p className={styles.stepDescription}>
						{t('section.solution.items.description1')}
						</p>
						<img src={stepProcess} className={styles.stepImage} />
					</span>
					<span className={styles.step}>
						<img src={stepSociogram} className={styles.stepImage} />
						<p className={styles.stepDescription}>
						{t('section.solution.items.description2')}
						</p>
					</span>
				</div>

			<img alt='half circle' src={halfCircle} className={styles.halfCircle}/>
			</div>
		</section>
	);
};

export default Solution;
